import { render, staticRenderFns } from "./institution-information.vue?vue&type=template&id=7bb61446&scoped=true&"
import script from "./institution-information.ts?vue&type=script&lang=ts&"
export * from "./institution-information.ts?vue&type=script&lang=ts&"
import style0 from "./institution-information.scss?vue&type=style&index=0&id=7bb61446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb61446",
  null
  
)

export default component.exports